import { render, staticRenderFns } from "./WorkspaceSigChainPathwayCard.vue?vue&type=template&id=c0db2070&scoped=true"
import script from "./WorkspaceSigChainPathwayCard.vue?vue&type=script&lang=js"
export * from "./WorkspaceSigChainPathwayCard.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceSigChainPathwayCard.vue?vue&type=style&index=0&id=c0db2070&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0db2070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0db2070')) {
      api.createRecord('c0db2070', component.options)
    } else {
      api.reload('c0db2070', component.options)
    }
    module.hot.accept("./WorkspaceSigChainPathwayCard.vue?vue&type=template&id=c0db2070&scoped=true", function () {
      api.rerender('c0db2070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceSigChainPathwayCard.vue"
export default component.exports